<template>
  <div style="margin-top:30px">
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      label-width="80px"
    >
      <el-row>
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item
              label="取消理由"
              prop="driverApplyRemark"
              style="margin-right:15px"
            >
              <el-input
                v-model="form.driverApplyRemark"
                type="textarea"
                :row="3"
              />
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button
        type="primary"
        @click="funcSubmit"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      pageType: "cancelOrder",
      form: {
        driverApplyRemark: "",
        isCancel: 1
      },
      rules: {
        driverApplyRemark: [
          { required: true, message: "请输入取消理由", trigger: "blur" },
          {
            min: 1,
            max: 500,
            message: "长度在 1 到 500 个字符"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    init(entity) {
      this.form.code = entity.code;
      this.form.driverApplyRemark = entity.driverApplyRemark;
    },
    funcSubmit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "ntocc-tms-api/orderDetail/driverCancelOrder",
            method: "put",
            params: data
          })
            .then(response => {
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherSubmitMethod", this.pageType);
              rLoading.close();
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", this.pageType);
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
